import React from 'react';
import Icon from './Icon';
import { scrollToId } from '../utils/scroll';

const STATS = [
  { value: '20+', label: 'Clients Served' },
  { value: '10+', label: 'Years of Expertise' },
  { value: '25%', label: 'Avg. Cost Reduction' },
  { value: '24/7', label: 'Support Coverage' },
];

const FLOATERS = [
  { icon: 'cloud', top: '8%', left: '4%', delay: '0s' },
  { icon: 'robot', top: '62%', left: '2%', delay: '0.6s' },
  { icon: 'shield-check', top: '4%', left: '78%', delay: '1.1s' },
  { icon: 'chart-bar', top: '68%', left: '80%', delay: '0.3s' },
  { icon: 'cpu', top: '38%', left: '86%', delay: '0.9s' },
];

export default function Hero() {
  return (
    <section id="hero" className="hero">
      <div className="grid-bg" aria-hidden="true" />
      <div className="container hero-container">
        <div className="hero-content reveal">
          <span className="hero-badge">
            <Icon name="sparkles" size={16} /> IT &amp; Automation Consulting
          </span>
          <h1 className="hero-title">
            Transforming Business Through <span>IT &amp; Intelligent Automation</span>
          </h1>
          <p className="hero-subtitle">
            We help organizations improve productivity, reduce costs, accelerate growth, and scale
            operations with enterprise-grade IT and automation solutions.
          </p>
          <div className="hero-cta">
            {/* <button className="btn btn-primary btn-lg" onClick={() => scrollToId('contact')}>
              Schedule a Consultation <Icon name="arrow-right" size={18} />
            </button> */}
            <button className="btn btn-secondary btn-lg" onClick={() => scrollToId('services')}>
              Explore Services
            </button>
          </div>

          <div className="hero-stats">
            {STATS.map((s) => (
              <div className="hero-stat" key={s.label}>
                <strong>{s.value}</strong>
                <span>{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="hero-visual reveal">
          <div className="orbit">
            <div className="orbit-core">
              <Icon name="cpu" size={44} />
            </div>
            <div className="orbit-ring ring-1" />
            <div className="orbit-ring ring-2" />
            {FLOATERS.map((f, i) => (
              <div
                className="float-badge"
                key={i}
                style={{ top: f.top, left: f.left, animationDelay: f.delay }}
              >
                <Icon name={f.icon} size={22} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}